module.exports = __webpack_public_path__ + "img/1.0.79c3d260.png";